import axios, { AxiosRequestConfig } from 'axios';
// config
import { HOST_API } from 'src/config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API });

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
// ----------------------------------------------------------------------
export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  // const token = localStorage.getItem('token');
  const token = localStorage.getItem('accessToken');
  const [url, config] = Array.isArray(args) ? args : [args];
  const res = await axiosInstance.get(url, {
    ...config,
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};
//
// ---------------------------------------------------------------------- 

export const endpoints: any = {
  auth: {
    me: '/api/auth/me',
    login: '/api/auth/login',
    register: '/api/auth/register',
  },
  product: {
    list: '/api/product/list',
    details: '/api/product/details',
    search: '/api/product/search',
  },
  test: {
    login: '/admin/login',
    category: '/categories/get-category',
  },
  logs: {
    log: '/log/admin-logs',
  },
  roles: {
    viewRoles: '/admin/role_all',
    addRoles: '/admin/postroles',
    editRoles: (id: any) => `/admin/update_role/${id}`,
    viewRolesById: (id: any) => `/admin/get_roleId/${id}`,
    rolesStatus: '/admin/rolesStatus',
    deleteroles: (id: any) => `/admin/deleterole/${id}`,
  },
  common: {
    gender: '/common/get-gender',
    agerange: '/common/get-age-range',
    distance: '/common/get-distance-range',
    workoutfrequency: '/common/get-frequency',
    goals: '/common/get-goals',
    availabledays: '/common/get-days',
    bodytype: '/common/get-body-type',
    langguage: '/common/get-language',
    experience: '/common/get-experience-range',
    trainingstyle: '/common/get-training-style',
    sessiontype: '/common/get-session-type',
    equipments: '/common/get-equipments',
    classes: '/common/get-class',
    amenities: '/common/get-amenities',
    speciality: '/common/get-speciality',
    membershiptype: '/common/get-membership-type',
    certification: '/common/get-certification',
  },
 
  admin: {
    getalladmin: '/admin/getuser-all',
    deleteUserList: '/admin/delete-user/list',
    deleteUser: '/admin/delete-user/delete',
    chatSettings: '/admin/chat-settings',
    rolesStatus: '/admin/getallRole',
    register: '/admin/register',
    editAdminregister: (id: any) => `/admin/user-update/${id}`,
    getsingleadmin: '/admin/get/singleadminuser',
    getnewsingleadmin: '/admin/getsingle-admin',
    getproduct: '/admin/getproduct',
    forgotpassword: 'admin/forget-password-otp',
    forgototpverify: 'admin/forgotVerifying-Otp',
    resendotp: '/admin/resendotp',
    changeforgotpassword: 'admin/change-password',
    getuserpercent: '/admin/dashboard/getusers',
    totalcount: '/admin/dashboard/getcount',
    getbanner: '/admin/get_active_advt',
  },
  products: {
    getproduct: '/admin/getproduct',
    addproduct: '/admin/postaddproduct',
    getsingleproduct: '/admin/getproductbyid',
    updateproduct: '/admin/putupdateproduct',
    productstatus: '/admin/putstatusproduct',
    deleteproduct: '/admin/delete/productdelete',
  },
  advertisement: {
    getalladvt: '/admin/get_all_advt',
    addAdvt: '/admin/post_advt',
    advtdelete: (id: any) => `admin/delete_advt/${id}`,
    viewAdvtById: (id: any) => `/admin/get_advtbyid/${id}`,
    editAdvertisement: (id: any) => `/admin/update_advt/${id}`,
    updateStatus: `admin/put_status_advt`,
  },

  // subscription:{
  //   getsub: '/admin/payment/getransactionlist',
  // },

   bulkfile:{
bulkupload:'admin/bulk-upload-users',
bulkImportList:'/admin/bulk-import-list',
bulkImportRollback:'/admin/bulk-import-rollback',
  },

  facility: {
    getfacility: '/admin/get_facilityUser',
    statusfacility: '/admin/put_status_facilities',
    adminstatus: '/admin/dashboard/admin_status',
  },
  category: {
    getallcategory: 'admin/getallcategory',
    getParentdropdown: 'admin/getparentcategory',
    addcategory: '/admin/postaddcategory',
    getcategorybyid: '/admin/getcategorybyid',
  },
  appusers: {
    getallappuser: 'admin/get_appUser',
    sigleappuser: `/admin/get_single_appuser`,
    statusappuser: '/admin/put_status_appuser',
  },
  insurance: {
    getInsurance: '/admin/getinsurance',
    insuranceFilter: '/admin/get/insurancefilter',
    updateInsurance: '/admin/putinsurance_status',
  },
  certificate: {
    getCertificate: '/admin/getcertificate',
    certificateFilter: '/admin/get/certificatefilter',
    updateCertificateStatus: '/admin/putcertificate_status',
  },
  reportedpost: {
    getallreport: '/adminsf/getallpostreport',
    getreportstatus: '/adminsf/put/changereportstatus',
    getPostreport: '/adminsf/getpostreport',
    // getreportstatus : (id:any) => `/adminsf/getreportstatus/${id}`,
  },
  professional: {
    getprofessional: '/admin/get_proUser',

    statueprofessional: '/admin/put_status_prouser',
  },
  adminchangepassword: {
    changepassword: '/admin/change-old-password',
  },
  adminsparkfeed: {
    getbyidsparkfeed: '/adminsf/getuserbyid',
    getbyfollowers: '/adminsf/followers',
    getbyfollowing: '/adminsf/following',
  },
};
